import axiosInstance from './axiosConfig';

const REST_API_BASE_URL = '/students';
// const REST_API_BASE_URL = '/api';

export const getAllStudents = () => axiosInstance.get(REST_API_BASE_URL);

export const getStudentById = (id) => axiosInstance.get(`${REST_API_BASE_URL}/${id}`);

export const createStudent = (student) => axiosInstance.post(REST_API_BASE_URL, student);

export const updateStudent = (id, student) => axiosInstance.put(`${REST_API_BASE_URL}/${id}`, student);

export const updateStudentStatus = (id, studentStatus) => {
    return axiosInstance.patch(`${REST_API_BASE_URL}/${id}/status`, null, {
        params: { studentStatus },
    });
};

export const deleteStudent = (id) => axiosInstance.delete(`${REST_API_BASE_URL}/${id}`);

export const getStudentsByName = (fullName) => axiosInstance.get(`${REST_API_BASE_URL}/search/by-name`, { params: { fullName } });

export const getStudentByEmail = (emailAddress) => axiosInstance.get(`${REST_API_BASE_URL}/search/by-email`, { params: { emailAddress } });

export const getStudentsByGender = (gender) => axiosInstance.get(`${REST_API_BASE_URL}/search/by-gender`, { params: { gender } });

export const getStudentsByPhone = (phoneNumber) => axiosInstance.get(`${REST_API_BASE_URL}/search/by-phone`, { params: { phoneNumber } });

export const getTotalStudentCount = () => axiosInstance.get(`${REST_API_BASE_URL}/count`);
// Upload profile image for a student
export const uploadProfileImage = (studentId, profileImage) => {
    const formData = new FormData();
    formData.append("profileImage", profileImage);

    return axiosInstance.post(`${REST_API_BASE_URL}/${studentId}/uploadProfileImage`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
};

// Get profile image for a student
export const getProfileImage = (studentId) => {
    return axiosInstance.get(`${REST_API_BASE_URL}/${studentId}/profileImage`, {
        responseType: 'arraybuffer'
    });
};